import { call, put, takeLatest } from "redux-saga/effects";
import { httpGetVerifyTransaction } from "../../../services/transactions";

import {
  verifyTransactionFailure,
  verifyTransactionStart,
  verifyTransactionSuccess,
} from "../reducer";

function* verifyTransaction({ payload }) {
  const { onSuccess, onFailure } = payload;
  const response = yield call(httpGetVerifyTransaction, payload);

  const { success, raw } = response;

  if (success) {
    yield put(verifyTransactionSuccess());

    if (onSuccess) {
      onSuccess(raw);
    }
  } else {
    yield put(verifyTransactionFailure(raw));

    if (onFailure) {
      onFailure();
    }
  }
}

export default function* onVerifyTransaction() {
  yield takeLatest(verifyTransactionStart.type, verifyTransaction);
}
